export default "__VITE_ASSET__5909bb4e__"